<div class="database-table"
     [style.left.px]="x"
     [style.top.px]="y"
     [style.z-index]="zIndex"
     draggable="true"
     (dragstart)="onDragStart($event)">

  <!-- Table Header -->
  <div class="table-header">
    <div class="table-title">
      <mat-icon class="table-icon">table_chart</mat-icon>
      <span class="table-name">{{ dataset.datasetReferenceTable.datasetName }}</span>
    </div>
    <button
      class="remove-btn"
      (click)="onRemove()"
      mat-icon-button
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Table Content -->
  <div class="table-content">
    <!-- Field Header -->
    <div class="column-row field-header">
      <div class="field-name">Field Name</div>
      <div class="field-type">Data Type</div>
    </div>

    <!-- Field Rows -->
    <div *ngFor="let column of getDatasetColumns(dataset); let columnIndex = index"
         class="column-row"
         [class.selected]="isFieldSelected(column.fieldName)"
         [attr.data-table-index]="index"
         [attr.data-field-name]="column.fieldName"
         (click)="onFieldClick(column.fieldName)">
      <div class="field-name">{{ column.fieldName }}</div>
      <div class="field-type">{{ column.dataType }}</div>
    </div>
  </div>
</div>
